<div class="navbar navbar-expand navbar-dark bg-primary mb-4">
    <div class="container-fluid">
        <a routerLink="/" class="navbar-brand">Angular App</a>
        <div>
          <ul class="navbar-nav ml-auto">
            <li class="nav-item">
              <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ 'exact' : true }" class="nav-link">Home <span class="sr-only">(current)</span> </a>
            </li>
            <li class="nav-item">
              <a routerLink="/users" routerLinkActive="active" class="nav-link">Users</a>
            </li>
            <li class="nav-item">
              <a routerLink="/posts" routerLinkActive="active" class="nav-link">Posts</a>
            </li>
          </ul>
        </div>
    </div>
</div>
